
export default function Footer() {
  return (
    <footer className="bg-cream py-8 px-4 border-t border-gray-200">
      <div className="max-w-6xl mx-auto text-center">
        <div className="mb-4">
          <span className="text-2xl font-script text-navy">The Neighborhood Brew</span>
        </div>
        <p className="text-navy/70 text-sm mb-4">
          Brewed with love in the neighborhood
        </p>
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-navy/60 text-sm">
            © 2025 The Neighborhood Brew. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
